import { getDateSchema } from '@breezeventures/web-ph-validators/zod-schemas';
import { requiredStringArray } from '@breezeventures/web-ph-validators/zod-utils';
import { startOfDay, subDays } from 'date-fns';
import { z } from 'zod';

import { documentSchema } from './document-schema';

export const businessDetailsSchema = z.object({
  registeredBusinessName: z
    .string()
    .trim()
    .min(1, 'Registered business name is required'),
  registrationDate: getDateSchema({
    required: true,
    requiredMessage: 'Registration date is required',
    maxDate: startOfDay(subDays(new Date(), 1)),
    rangeMessage: 'Registration date must be before today',
  }),
  tinCode: z
    .string()
    .trim()
    .min(1, 'TIN is required')
    .regex(/^\d{9,13}$/, 'TIN must have 9-13 digits'),
  brandName: z.string().trim().min(1, 'Brand name is required'),
  brandIcon: documentSchema.nullish(),
  otherFinancingPartners: requiredStringArray('Select financing partners'),
  companyCategories: requiredStringArray('Select category'),
  companyCategoryOther: z.string().optional(),
});

export const getBusinessDetailSchemaWithRequiredOther = (
  otherOptionId: string | undefined
) => {
  return businessDetailsSchema.refine(
    (data) =>
      !otherOptionId ||
      !data.companyCategories?.includes(otherOptionId) ||
      (data.companyCategoryOther?.trim().length ?? 0) > 0,
    { message: 'Company category is required', path: ['companyCategoryOther'] }
  );
};

export type BusinessDetailsFormValues = z.infer<typeof businessDetailsSchema>;
